import store from '@/store';

export default class WhatsAppTransferResponseEvent {
  constructor(body) {
    if (
      Object.hasOwn(body, 'supervisorId') &&
      Object.hasOwn(body, 'protocol')
    ) {
      const { supervisorId, protocol } = body;
      store.dispatch('jobs/removeJob', protocol);
      store.dispatch('observation/clearObservation', protocol);
      store.dispatch('jobs/updateAgentStatusWhatsApp');
    }
  }
}
